import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const FounderPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="創辦人陳鋒玲 Katy Chen｜全球頂尖高能動性引導師 High Agency Facilitator"
        description="陳鋒玲（Katy Chen）為明悅文化 Ming Yue Culture 創辦人、全球頂尖高能動性 High Agency 引導師，結合台大化學系背景與遊戲化學習（Game-based Learning），以生命教育與賦能系統陪伴全球企業與新世代青年成長。"
        path="/founder"
        keywords="陳鋒玲, Katy Chen, 明悅文化創辦人, 明悅心創創辦人, 高能動性引導師, High Agency Facilitator, 生命教育, 遊戲化學習, 賦能, 成長, 學習, 明悅心創, 明悅文化"
      />
      <Header />
      
      {/* Hero Section with Image */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="container mx-auto px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-5xl font-bold text-gray-800 mb-4">創辦人</h1>
              <p className="text-2xl text-orange-500 font-medium">About the Founder</p>
            </div>

            {/* Founder Profile */}
            <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Image Section */}
                <div className="bg-gradient-to-br from-orange-100 to-yellow-100 p-8 flex items-center justify-center">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_instant-website-93/artifacts/d72hrbk6_%E9%99%B3%E9%8B%92%E7%8E%B2%E5%BD%A2%E8%B1%A1%E7%85%A7-%E9%BB%83.jpeg"
                    alt="陳鋒玲 Katy Chen"
                    className="w-full h-auto rounded-2xl shadow-xl object-cover"
                  />
                </div>

                {/* Title Section */}
                <div className="p-8 lg:p-12 flex flex-col justify-center">
                  <h2 className="text-4xl font-bold text-gray-800 mb-4">
                    陳鋒玲 Katy Chen
                  </h2>
                  <div className="space-y-3 mb-6">
                    <p className="text-xl text-orange-600 font-semibold">
                      明悅心創教育文化  創辦人
                    </p>
                    <p className="text-xl text-orange-600 font-semibold">
                      未來青年智慧發展中心  主席
                    </p>
                    <p className="text-lg text-gray-600 italic">
                      Founder of Mingyue Culture<br />
                      Chapter President of Future Intelligence Institute for Youth (FIY)
                    </p>
                  </div>
                  
                  <div className="bg-gradient-to-r from-orange-400 to-red-400 rounded-2xl p-6 text-white">
                    <p className="text-2xl font-bold mb-2">
                      全球高能動性引導師與生命教育先驅
                    </p>
                    <p className="text-lg italic">
                      Global High-Agency Facilitator & Life Education Pioneer
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Story Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">創辦人初心</h2>
            <p className="text-2xl text-center text-orange-500 font-medium mb-12">The Master's Vision</p>

            <div className="bg-gradient-to-br from-orange-50 to-yellow-50 rounded-2xl p-8 mb-8">
              <p className="text-2xl text-center text-gray-800 font-semibold leading-relaxed mb-4">
                「用遊戲改寫人生劇本，以高能動性驅動跨國影響力。」
              </p>
              <p className="text-xl text-center text-gray-700 leading-relaxed">
                「不只是教育，更是文化的浸潤；不僅有財商，更有生命教育。」
              </p>
            </div>

            {/* Brand Master Image */}
            <div className="rounded-2xl overflow-hidden shadow-2xl mb-12">
              <img
                src="https://customer-assets.emergentagent.com/job_instant-website-93/artifacts/g33ek5ny_%E5%89%B5%E8%BE%A6%E4%BA%BA%E7%B6%B2%E7%AB%99%E7%85%A7%E7%89%87.gif"
                alt="陳鋒玲 Katy Chen — GenFuture Intelligence Global Forum 全球永續教育創新論壇"
                className="w-full h-auto"
              />
            </div>

            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                陳鋒玲（Katy Chen）是一位兼具嚴謹科學理性與深厚人文關懷的生命教育創新者。她畢業於國立台灣大學（NTU）化學系，帶著對系統演算與邏輯底層的洞察，投身於生命心智模式的重塑志業。身為兩個女兒的母親，她深刻體會到現代人在高速變動、AI 衝擊的集體焦慮中，內在掌控力的失落。
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                她深信，面對未來的唯一解法，是喚醒人類最核心的武器——<span className="font-bold text-orange-600">高能動性（High Agency）</span>。她不給予僵化的標準答案，而是像一輪明月般，以溫暖包容的母性能量守護、陪伴著每一個來到面前的生命，帶領人們在極度放鬆的氛圍中重拾純粹童心，親手把自己的破局力量「玩」出來。
              </p>

              <div className="bg-gray-50 rounded-2xl p-6 border-l-4 border-orange-400">
                <p className="text-lg text-gray-700 leading-relaxed italic">
                  "More than education, it is a cultural immersion. Financial intelligence is the mirror to see reality; life education is the key to rewriting your script."
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mt-4">
                  Katy Chen is a visionary life education innovator combining a rigorous scientific background from National Taiwan University (Chemistry) with deep humanistic care. As a mother of two and a certified coach, she deeply understands the collective anxiety and loss of agency in the AI era. She believes the ultimate solution is to awaken High Agency.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mt-4">
                  Instead of imposing rigid answers, she acts like a full moon—nurturing, supportive, and protective. Through Game-based Learning, she guides individuals to embrace their inner youth, relax their defenses, and intentionally rewrite their life scripts through experiential practice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Milestones Section */}
      <section className="py-16 bg-gradient-to-br from-orange-50 to-yellow-50">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">核心里程碑與實證背書</h2>
            <p className="text-2xl text-center text-orange-500 font-medium mb-12">Core Milestones & Proven Impact</p>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              鋒玲引導師深耕 <span className="font-bold text-orange-600">Game-based Learning（遊戲化學習）</span> 與 <span className="font-bold text-orange-600">Life Simulation（生命模擬遊戲）</span> 領域逾六年。她將這套系統從個人的家庭式推演，一路開拓至企業、校園與國際舞台，創造了極具厚度的社會影響力：
            </p>

            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h4 className="text-2xl font-bold text-orange-600 mb-3">
                  全球 500 強與金融機構組織賦能
                </h4>
                <p className="text-lg text-gray-700 leading-relaxed">
                  受邀進入全球500強企業與大型金融機構，推動「員工金錢心理健康工作坊」，協助經理人破除財務與決策盲點，照料組織的心理韌性。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h4 className="text-2xl font-bold text-orange-600 mb-3">
                  新世代青年高能動性孵化
                </h4>
                <p className="text-lg text-gray-700 leading-relaxed">
                  走入台灣在地數十所國中小學深耕生命教育；並主持大專院校創業營隊與全球領袖論壇，將高能動性的心智種子深植於未來青年心中。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h4 className="text-2xl font-bold text-orange-600 mb-3">
                  全球引導師生態系母體
                </h4>
                <p className="text-lg text-gray-700 leading-relaxed">
                  六年來淬鍊、培育出橫跨【財富流】、【時空流】與【明日之星】三大模擬系統的專業教練與引導師團隊，形成立足台灣、輻射全球的複利人才基地。
                </p>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h4 className="text-2xl font-bold text-orange-600 mb-3">
                  國際永續教育論壇代表
                </h4>
                <p className="text-lg text-gray-700 leading-relaxed">
                  代表組織親赴巴黎聯合國教科文組織（UNESCO）總部參與國際教育日論壇，將台灣的遊戲化教育創新實力與東方「富而喜悅」的生命文化推向國際舞台。
                </p>
              </div>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 mt-8 border-l-4 border-orange-400">
              <p className="text-lg text-gray-700 leading-relaxed">
                With over six years of mastery in Game-based Learning, Feng-Ling has elevated life simulation from personal workshops to a globally scalable ecosystem:
              </p>
              <ul className="mt-4 space-y-3 text-lg text-gray-700">
                <li><strong>Corporate & Organizational Well-being:</strong> Invited by Global 500 companies and financial institutions to drive "Financial Mental Health Workshops," clearing decision-making blind spots and enhancing corporate resilience.</li>
                <li><strong>Youth Leadership & Sustainable Education:</strong> Deeply rooted in dozens of primary, secondary, and tertiary institutions, steering entrepreneurship camps and global leadership forums to cultivate high agency in the next generation.</li>
                <li><strong>Global Coach Ecosystem:</strong> Cultivated a high-caliber network of certified facilitators across Wealth Flow, Space-Time Flow, and Star of Tomorrow systems, forming an international talent hub based in Taiwan.</li>
                <li><strong>Global Advocacy at UNESCO:</strong> Represented the organization at the UNESCO Headquarters in Paris for the International Day of Education, bringing Taiwan's game-based educational innovation and Eastern "Wealth & Joy" culture to the global stage.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Future Vision Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-4xl font-bold text-center text-gray-800 mb-4">邁向全球的未來願景</h2>
            <p className="text-2xl text-center text-orange-500 font-medium mb-12">Future Journey</p>

            <div className="space-y-6">
              <p className="text-lg text-gray-700 leading-relaxed">
                現在，鋒玲引導師正帶領著明悅心創的核心教練團，從個人商業模式正式走向「全球版權與文化輸出」。以台灣為堅固的實踐基地，逐步將遊戲化教學反思與引導系統結合 AI 科技工具，輸出至歐洲及全球。她將持續以大師的格局與明月般的溫暖，陪伴全球更多的人、家庭與企業，解鎖內在掌控力，真正活出物質豐盛與精神安詳的「富而喜悅」生命文化。
              </p>

              <div className="bg-gradient-to-r from-orange-400 to-red-400 rounded-2xl p-8 text-white">
                <p className="text-lg leading-relaxed italic">
                  Today, Feng-Ling is leading her core facilitator team beyond personal coaching into a platform-based model of Global Cultural Licensing. Leveraging AI-driven reflective tools and strategic academic research, she is exporting this Eastern-created life simulation culture from Taiwan to Europe and beyond—empowering souls worldwide to live a life of true wealth and joy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FounderPage;
